import { Component, Input } from '@angular/core';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { SessionService } from "src/app/session.service";
import { environment } from "src/environments/environment";
import * as CryptoJS from 'crypto-js';
import { Router, NavigationEnd } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserRoleService } from 'src/app/shared/user-role.service';
import { ExecutiveHighlightService } from '../../shared/ExecutiveHighlightService.service';

@Component({
    selector: 'app-dashboard-switcher',
    templateUrl: './dashboard-switcher.component.html',
    styleUrls: ['./dashboard-switcher.component.css'],
    standalone: false
})
export class DashboardSwitcherComponent {
private storage = environment.storage;
dashboards: string[] = [];
plant: any[] = [];
teamMembers: any[] = [];
loginForm: any;
errorMessage: string = "";
@Input() admin_id: number | null = null; 
userRole: number | null = null; // Initialize userRole to null
executiveMembers: any[] = [];
executive: any[] = [];
highlightedExecutiveIndex: number | null = null;
highlightedExecutiveRole: number | null = null;
mode: 'plant' | 'executive' = 'plant';
executiveLinks: any[] = []; // To hold executive links for the selected executive
selectedExecutiveIndex: number | null = null;
currentSiteId: number | null = null;
currentSiteName: string = '';

constructor(private userService: UserManagementService, private router: Router, private sessionService: SessionService, private userRoleService: UserRoleService, private executiveHighlightService: ExecutiveHighlightService) {
    
}

ngOnInit(): void {
    this.fetchUsers();
    this.fetchUsersE();
   this.executiveHighlightService.highlightedIndex$.subscribe(index => {
    this.highlightedExecutiveIndex = index;
  });
  this.executiveHighlightService.highlightedRole$.subscribe(role => {
    this.highlightedExecutiveRole = role;
  });

  const mode = localStorage.getItem('dashboardSwitcherMode');
  if (mode === 'executive') {
    this.mode = 'executive';
    const idx = localStorage.getItem('dashboardSwitcherExecutiveIndex');
    this.selectedExecutiveIndex = idx ? Number(idx) : null;
  } else {
    this.mode = 'plant';
    this.selectedExecutiveIndex = null;
  }

  // Load current site info from localStorage
  this.loadCurrentSiteInfo();
}

loadCurrentSiteInfo() {
  const storedSiteId = localStorage.getItem('currentSiteId');
  const storedSiteName = localStorage.getItem('currentSiteName');
  if (storedSiteId) {
    this.currentSiteId = Number(storedSiteId);
  }
  if (storedSiteName) {
    this.currentSiteName = storedSiteName;
  }
}

isCurrentSite(siteId: number): boolean {
  return this.currentSiteId === siteId;
}

// Helper method to build login payload with conditional role_type
buildLoginPayload(username: string, hashedPassword: string): any {
  const loginPayload: any = {
    email: username,
    password: hashedPassword,
    purpose: "login"
  };

  // Add role_type = 16 if original admin had role 16 and visited user management sites
  const originalAdminRole = sessionStorage.getItem('originalAdminRole');
  const visitedUserManagementSites = sessionStorage.getItem('visitedUserManagementSites') === 'true';
  
  // Debug logging
  console.log('buildLoginPayload - originalAdminRole:', originalAdminRole);
  console.log('buildLoginPayload - visitedUserManagementSites:', visitedUserManagementSites);
  
  // Check if original admin had role 16 and visited user management sites
  if (originalAdminRole === '16' && visitedUserManagementSites) {
    loginPayload.role_type = 16;
    console.log('buildLoginPayload - Added role_type: 16 to payload');
  }

  console.log('buildLoginPayload - Final payload:', loginPayload);
  return loginPayload;
}
fetchUsers() {
  // Get admin_user_id from session storage (not localStorage)
  const admin_user_id = Number(sessionStorage.getItem('admin_id'));

  this.userService.getPlants(admin_user_id).subscribe(response => {
    if (response.status === 1) {
      this.plant = response.plants;

      // Dynamically populate teamMembers based on the fetched plants
      this.teamMembers = this.plant.map((plant, index) => {
        const mappedMember = {
          name: `${plant.site_name}`, // Placeholder name
          site_id: plant.site_id,
          user_id: plant.user_id,
          admin_id: plant.admin_user_id,
        };
        return mappedMember;
      });
    } else {
      // handle error
    }
  });
}

fetchUsersE() {
       const admin_user_id = Number(sessionStorage.getItem('admin_id'));
      this.userService.getExecutive(admin_user_id).subscribe(response => {
      if (response.status === 1) {
        this.executive = response.executives;

        // Dynamically populate executiveMembers based on the fetched executives
        this.executiveMembers = this.executive.map((exec, index) => {
        const mappedExecutive = {
          name: `${exec.site_name}`, // Placeholder name
          site_id : exec.site_id,
          user_id: exec.executive_id,
          admin_id: exec.admin_user_id,
        };
        return mappedExecutive;
        });
      } else {
        // handle error
      }
      });
    }


  isPanelOpen = false;

  togglePanel() {
    this.isPanelOpen = !this.isPanelOpen;
  }
switchToPlantDashboard() {
  // 1. Get admin_user_id from session storage
  const admin_user_id = Number(sessionStorage.getItem('admin_id'));

  // 2. Call API to get username and password for this admin_user_id
  this.userService.getAdminCredentials(admin_user_id).subscribe(
    (response: any) => {
      if (response.status === 1 && response.username && response.password) {
        const username = response.username;
        let password = response.password;

        // Trim last 6 characters of password
        password = password.slice(0, -6);

        // Hash the password
        const SECRET_KEY = "purbi123";
        const hashedPassword = CryptoJS.AES.encrypt(password, SECRET_KEY).toString();

        // Prepare the login payload with conditional role_type
        const loginPayload = this.buildLoginPayload(username, hashedPassword);

        // 3. Call the login method
        this.userService.login(loginPayload).then((loginResponse: any) => {
          if (loginResponse.status === 1) {

            // Apply the provided logic after successful login
            if (loginResponse && loginResponse.status === 1 && loginResponse.user) {
              const siteInfo = JSON.parse(JSON.stringify(loginResponse.user.allsites));
              delete loginResponse.user.allsites;
              this.userService.addUserDetail(loginResponse.user);
              this.userService.addSiteDetails(siteInfo);
              this.sessionService.resetSessionTimeout();

              // Redirect to /user-management-sites on successful login
              this.router.navigate(["/user-management-sites"]).then(() => {});
            } else {
              this.loginForm.get("password").setValue("");
              this.errorMessage = loginResponse.msg || "Invalid login credentials.";
            }
          } else {
            // handle error
          }
        }).catch((error) => {
          // handle error
        });
      } else {
        // handle error
      }
    },
    (error) => {
      // handle error
    }
  );
}

  switchUser(mappedMember: { site_id: number; user_id: number; name?: string }) {
        this.mode = 'plant';
        localStorage.setItem('dashboardSwitcherMode', 'plant');
        localStorage.setItem('currentSiteId', mappedMember.site_id.toString());
        localStorage.setItem('currentSiteName', mappedMember.name || '');
        localStorage.setItem('currentDashboardType', 'plant');
        this.currentSiteId = mappedMember.site_id;
        this.currentSiteName = mappedMember.name || '';
        const adminId = Number(localStorage.getItem('admin_id')); // Retrieve admin ID
        const { site_id, user_id } = mappedMember; // Destructure site_id and user_id from mappedMember
  
        this.userService.getUserCredentials(user_id).subscribe(
          (response: any) => {
            if (response.status === 1 && response.username && response.password) {
              const { username, password } = response; // Directly access username and password
  
              // Hash the password
              const SECRET_KEY = "purbi123";
              const hashedPassword = CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
  
              // Prepare the login payload with conditional role_type
              const loginPayload = this.buildLoginPayload(username, hashedPassword);
  
              // Call the login method
              this.userService.login(loginPayload).then((loginResponse: any) => {
                if (loginResponse.status === 1) {
  
                  // Apply the provided logic after successful login
                  if (loginResponse && loginResponse.status === 1 && loginResponse.user) {
                    const siteInfo = JSON.parse(JSON.stringify(loginResponse.user.allsites));
                    delete loginResponse.user.allsites;
                    this.userService.addUserDetail(loginResponse.user);
                    this.userService.addSiteDetails(siteInfo);
                    this.sessionService.resetSessionTimeout();
  
                    if (loginResponse.user.role === 16) {
                      this.router.navigate(["/user-management-sites"]).then(() => {});
                    } else if (loginResponse.user.role === 13) {
                      this.router.navigate(["reportlibrary/editreport/process"]);
                    } else {
                      this.router.navigate(["/"]).then(() => {
                        window.location.reload();
                      });
                    }
                  } else {
                    this.loginForm.get("password").setValue("");
                    this.errorMessage = loginResponse.msg || "Invalid login credentials.";
                  }
                } else {
                  // handle error
                }
              }).catch((error) => {
                // handle error
              });
            } else {
              // handle error
            }
          },
          (error) => {
            // handle error
          }
        );
      }

      switchExecutive(mappedExecutive: { site_id: number; user_id: number; name?: string }, executive: any, index: number) {
            this.executiveHighlightService.setHighlight(index, 12);
            localStorage.setItem('currentSiteId', mappedExecutive.site_id.toString());
            localStorage.setItem('currentSiteName', mappedExecutive.name || '');
            localStorage.setItem('currentDashboardType', 'executive');
            this.currentSiteId = mappedExecutive.site_id;
            this.currentSiteName = mappedExecutive.name || '';
            const adminId = Number(localStorage.getItem('admin_id')); // Retrieve admin ID
            const { site_id, user_id } = mappedExecutive; // Destructure site_id and user_id from mappedExecutive
      
            this.userService.getUserCredentials(user_id).subscribe(
              (response: any) => {
                if (response.status === 1 && response.username && response.password) {
                  const { username, password } = response; // Directly access username and password
      
                  // Hash the password
                  const SECRET_KEY = "purbi123";
                  const hashedPassword = CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
      
                  // Prepare the login payload with conditional role_type
                  const loginPayload = this.buildLoginPayload(username, hashedPassword);
      
                  // Call the login method
                  this.userService.login(loginPayload).then((loginResponse: any) => {
                    if (loginResponse.status === 1) {
      
                      // Apply the provided logic after successful login
                      if (loginResponse && loginResponse.status === 1 && loginResponse.user) {
                        const siteInfo = JSON.parse(JSON.stringify(loginResponse.user.allsites));
                        delete loginResponse.user.allsites;
                        this.userService.addUserDetail(loginResponse.user);
                        this.userService.addSiteDetails(siteInfo);
                        this.sessionService.resetSessionTimeout();
      
                        if (loginResponse.user.role === 16) {
                          this.router.navigate(["/user-management-sites"]).then(() => {});
                        } else if (loginResponse.user.role === 13) {
                          this.router.navigate(["reportlibrary/editreport/process"]);
                        } else {
                          this.router.navigate(["/"]).then(() => {
                            window.location.reload();
                          });
                        }
                      } else {
                        this.loginForm.get("password").setValue("");
                        this.errorMessage = loginResponse.msg || "Invalid login credentials.";
                      }
                    } else {
                      // handle error
                    }
                  }).catch((error) => {
                    // handle error
                  });
                } else {
                  // handle error
                }
              },
              (error) => {
                // handle error
              }
            );
          }
}
